<template>
  <div class="row">
    <div class="col-md-12">
      <h2>Cargados {{ uploadedAnnexes }} de {{ totalAnnexes }} anexos</h2>
      <table id="annexes">
        <tr v-for="(vi, i) in inputs" :key="i">
          <td :class="classes(i)">{{ vi.annexed.letter }}</td>
          <td class="name">
            <b
              v-if="vi.annexed.is_required"
              class="text-danger"
              style="font-size: 18px !important"
              >*</b
            >
            <span v-html="vi.annexed.name"></span>
            <div
              class="row mb-2"
              v-for="(vj, j) in vi.acc_annexes_files"
              :key="j"
            >
              <div class="col-12 col-md-5">
                <app-input
                  :id="`filename_${i}${j}`"
                  type="text"
                  v-model="vj.filename"
                  placeholder="Descripcion del archivo"
                  :disabled="disabled"
                  @keyup="onKeyUp(i, j)"
                />
              </div>

              <div class="col-12 col-md-5" v-if="!vj.annexed">
                <app-input
                  :id="`file_${i}${j}`"
                  type="file"
                  :label="vj.file ? vj.file.name : $t('upload_your_file')"
                  v-model="vj.file"
                  :disabled="disabled"
                  @change="onChange($event, i, j)"
                />
              </div>

              <div class="col-12 col-md-2 text-center" v-if="vj.loading">
                <div class="spinner-border text-info" role="status"></div>
              </div>

              <div
                class="col-12 col-md-2 text-center"
                v-if="!vj.annexed && !vj.loading"
              >
                <button
                  type="submit"
                  class="btn btn-warning"
                  @click="removeRowFile(i, j)"
                  v-if="!vj.annexed"
                >
                  <app-icon name="slash" /> Quitar
                </button>
              </div>

              <div
                class="col-12 col-md-6 text-center"
                v-if="vj.annexed && !vj.loading"
              >
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(vj.annexed)"
                >
                  <app-icon name="file" /> Ver
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="openDeleteModal(i, j, vj)"
                  v-if="!disabled"
                >
                  <app-icon name="trash-2" /> Eliminar
                </button>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-12">
                <button
                  type="submit"
                  class="btn btn-primary"
                  @click="addFile(i, vi)"
                  v-if="!disabled"
                >
                  <app-icon name="plus" /> Agregar archivo
                </button>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <app-input
                  v-if="showObservation(i)"
                  type="textarea"
                  v-model="vi.observations"
                  placeholder="Observaciones"
                  :disabled="true"
                />
              </div>
            </div>
          </td>
        </tr>
      </table>
      <h2>Cargados {{ uploadedAnnexes }} de {{ totalAnnexes }} anexos</h2>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost, axiosDelete } from "@/app/helpers/AxiosHelper";
export default {
  name: "AnnexedList",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      deleteModal: false,
      inputs: [],
      tmp: {},
      delayTimer: null,
    };
  },

  computed: {
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },

    disabled() {
      return this.status != "100" && this.status != "112";
    },

    totalAnnexes() {
      return this.inputs.length;
    },

    uploadedAnnexes() {
      return this.inputs.filter((item) => item.acc_annexes_files.length > 0)
        .length;
    },

    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
  },

  created() {
    this.data();
  },

  methods: {
    data() {
      this.preloader = true;

      this.axiosGet(
        `/annexes/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.inputs = response.data ? response.data : {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    classes(index) {
      let tmp = "letter ";
      if (this.status != "100") {
        tmp += this.inputs[index].is_approved ? "btn-success" : "btn-danger";
      }
      return tmp;
    },

    showObservation(index) {
      return this.inputs[index].is_approved == "0" && this.status == "112";
    },

    onChange(e, i, j) {
      const tmp = this.inputs[i].acc_annexes_files[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8000000) {
        this.$set(this.inputs[i].acc_annexes_files[j], "file", null);
        this.$set(this.inputs[i].acc_annexes_files[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }

      if (!tmp.filename)
        this.$set(
          this.inputs[i].acc_annexes_files[j],
          "filename",
          e.target.files[0].name
        );

      this.chargeFile(i, j);
    },

    onKeyUp(i, j) {
      const tmp = this.inputs[i].acc_annexes_files[j];
      if (!tmp.annexed || !tmp.filename || tmp.filename.length == 0) return;
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(() => this.chargeFile(i, j), 1000);
    },

    chargeFile(i, j) {
      this.inputs[i].acc_annexes_files[j].loading = true;
      this.deleteLoader = true;
      const url = `/annexes`;
      let formData = new FormData();

      for (const [key, value] of Object.entries(
        this.inputs[i].acc_annexes_files[j]
      )) {
        formData.append(key, value);
      }

      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          const { data } = res.data;
          const tmp = [...this.inputs[i].acc_annexes_files];
          tmp[j] = data;
          this.$set(this.inputs[i], "acc_annexes_files", tmp);
        })
        .catch(({ error }) => {})
        .finally(() => {
          this.inputs[i].acc_annexes_files[j].loading = false;
        });
    },

    addFile(i, vi) {
      if (this.inputs[i].acc_annexes_files.length >= 249) {
        this.$toastr.e(
          "Solo se pueden adjuntar un maximo de 250 archivos por anexo"
        );
        return;
      }
      const tmp = [...this.inputs[i].acc_annexes_files];
      tmp.push({
        record_id: vi.id,
        filename: null,
        file: null,
      });
      this.$set(this.inputs[i], "acc_annexes_files", tmp);
    },

    removeRowFile(i, j) {
      const tmp = this.inputs[i].acc_annexes_files.filter(
        (value, index) => index != j
      );
      this.$set(this.inputs[i], "acc_annexes_files", tmp);
    },

    openTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(i, j, vj) {
      this.deleteModal = true;
      this.tmp = {
        i: i,
        j: j,
        vj: vj,
      };
    },

    confirmed() {
      const url = `/annexes?acc_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          const { data } = res.data;
          const tmp = this.inputs[this.tmp.i].acc_annexes_files.filter(
            (value, index) => index != this.tmp.j
          );
          this.$set(this.inputs[this.tmp.i], "acc_annexes_files", tmp);
        })
        .catch(({ error }) => {});
    },

    cancelled() {
      this.deleteModal = false;
    },
  },
};
</script>

<style lang="css">
#annexes {
  width: 100%;
}
#annexes tr {
  border: 1px dotted gray;
}
#annexes td {
  padding: 0.8rem;
}
#annexes .letter {
  width: 5%;
  text-align: center;
}
#annexes .name {
  text-align: justify;
}
#annexes .attached-file {
  width: 10%;
  text-align: center;
}
</style>